import React from "react";
import { Box, Button, Link, Text } from "@opendoor/bricks-next";
//#region src/AccountForm/AccountFormCinderblocks/CheckEmailForm.tsx
var CheckEmailForm = ({ hasGeneratedPassword, email, analyticsName, onResetValidEmail, requestResetPassword }) => {
	const headerText = hasGeneratedPassword ? "Set up your account" : "Check your email", emailInstructionText = hasGeneratedPassword ? `First, check your email and click the link to set up your password. We emailed a link to ${email}.` : `We’ve sent reset password instructions to ${email}. Once you’ve reset your password, sign in again.`;
	return /* @__PURE__ */ React.createElement(Box, { gap: "$20x" }, /* @__PURE__ */ React.createElement(Box, { gap: "$10x" }, /* @__PURE__ */ React.createElement(Text, {
		tag: "h2",
		typography: "$headerMedium"
	}, headerText), /* @__PURE__ */ React.createElement(Text, {
		tag: "p",
		typography: "$bodySmall"
	}, emailInstructionText)), hasGeneratedPassword ? /* @__PURE__ */ React.createElement(React.Fragment, null, requestResetPassword && /* @__PURE__ */ React.createElement(Button, {
		variant: "primary",
		size: "small",
		label: "Resend email",
		onPress: () => requestResetPassword(email),
		analyticsName: `${analyticsName}-resend-reset-password-email`,
		"aria-label": "Resend email"
	}), /* @__PURE__ */ React.createElement(Text, {
		tag: "p",
		typography: "$bodyMedium"
	}, "We’ve sent reset password instructions to ", email, ". Once you’ve reset your password,", " ", /* @__PURE__ */ React.createElement(Link, {
		variant: "primary",
		href: "/login",
		size: "medium",
		onPress: onResetValidEmail,
		analyticsName: `${analyticsName}-sign-in-after-reset-password`,
		"aria-label": "Sign In",
		"data-testid": "sign-in-after-reset-password"
	}, "sign in again"))) : /* @__PURE__ */ React.createElement(Button, {
		variant: "primary",
		size: "small",
		label: "Sign In",
		onPress: onResetValidEmail,
		analyticsName: `${analyticsName}-sign-in-after-reset-password`,
		"aria-label": "Sign In",
		"data-testid": "sign-in-after-reset-password"
	}));
};
//#endregion
export { CheckEmailForm };

